module.exports = __webpack_public_path__ + "static/media/pen.4321580d.svg";